export function initLoginError() {
	document.addEventListener('DOMContentLoaded', () => {
		const noticesWrapper = document.querySelector('.woocommerce-notices-wrapper');
	
		if (noticesWrapper) {
			const errorElement = noticesWrapper.querySelector('.woocommerce-error');
	
			if (errorElement) {
				const clonedError = errorElement.cloneNode(true);
				const separator = document.querySelector('.separator');
	
				if (separator) {
					separator.parentNode.insertBefore(clonedError, separator.nextSibling);
				}
			}
		}
	});
	
}